import React from "react";
import { observer } from "mobx-react";
import emissionViewStore from "../../../Store/marco/emissionViewStore";
import styles from "../styles/EmissionActivityModal.module.css";
import loadingSvg from "../../../Assets/images/tube-spinner.svg";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { EAFormComponent } from "../form/EAFormComponent";
import { EFFormComponent } from "../form/EFFormComponent";
import { getEASchemaByStandard } from "../utils/getEASchemaByStandard";
import { getEFSchemaByStandard } from "../utils/getEFSchemaByStandard";
import { SchemaSwitcher } from "../utils/SchemaSwitcher";
import { shouldShow } from "../form/utils/shouldShow";
import { isPercentageInRange } from "../../utils/percentageValue";

export const EAEFModal = observer(() => {
  const { t } = useTranslation("ActivityMain");
  const {t:t1} = useTranslation("EFMain");
  const store = emissionViewStore;
  const EASchema = getEASchemaByStandard(store.standardId)[store.selectedTab];
  const EFSchema = getEFSchemaByStandard(store.standardId)[store.selectedTab];
  const cat = EASchema.cat; //// cat4_3
  const hasEAValidationError = (EASchema.fields || [])
    .filter(
      (field) =>
        field.percentageRange && shouldShow(field, store.EAFormData, null),
    )
    .some((field) => {
      const { min, max } = field.percentageRange;
      const value = store.getEAValue(field.level, field.key);
      return !isPercentageInRange(value, min, max);
    });

  const modalTitle = t(
    store.isEditEmissionActivity ? "Edit data for" : "Add data for"
  );
  const catTitle = t(
    store.isEditEmissionActivity
      ? store.selectedTab
      : store.selectedEmissionActivityModal
  );

  ////////關閉表單
  const handleCloseModal = () => {
    store._handleSetEFCheckId("");
    store._handleSetCloseEmissionActivityModal();
    store._handleReSetEAFormData();
    store._handleReSetEFFormData();
    store._handleReSetEFFormData("EFLandFormData");
    store._handleReSetEFFormData("EFSeaFormData");
    store._handleReSetEFFormData("EFAirFormData");
  };

  const actionHandler = async () => {
    if (hasEAValidationError) return;

    const fnAPI = store.isEditEmissionActivity ? store.editEA : store.addEA;
    try {
      await fnAPI();
    } catch (err) {
      console.log(err);
    }
  };

  const actionText = t(store.isEditEmissionActivity ? "Edit" : "Add");

  const isLoading = store.emissionActivityModalLoading >= 1;

  return (
    <div className={styles.bgc}>
      <div
        className={`${styles.container} ${isLoading ? styles.isLoading : ""}`}
      >
        {/** loading 頁面*/}
        {isLoading && (
          <div className={styles.loading}>
            <img className={styles.loadingImg} src={loadingSvg} alt="loading" />
          </div>
        )}

        {/** 標題 */}
        <div className={styles.title}>
          {modalTitle} {catTitle}
          <span className={styles.close} onClick={handleCloseModal}>
            <CloseIcon />
          </span>
        </div>

        {/**表單 */}
        <div className={styles.main}>
          {/**排放活動component */}
          {cat === "cat4_3" ? (
            <>
              <EAFormComponent
                EASchema={EASchema.normal}
                target={"EAFormData"}
              />
              <EFFormComponent
                EFSchema={EFSchema.normal}
                formDataKey={"EFFormData"}
                handleSetFormData={store._handleSetEFFormData}
                target={"EFFormData"}
              />
              <EAFormComponent
                EASchema={EASchema.tran}
                target={"landEAFormData"}
              />
              <EFFormComponent
                EFSchema={EFSchema.tran}
                formDataKey={"EFLandFormData"}
                handleSetFormData={store._handleSetEFFormData}
                target={"EFLandFormData"}
              />
            </>
          ) : (
            <EAFormComponent EASchema={EASchema} target={"EAFormData"} />
          )}

          {/**排放係數component */}
          {cat !== "cat4_3" && (
            <SchemaSwitcher cat={EFSchema?.cat} defaultEFSchema={EFSchema} />
          )}
        </div>

        {/**footer */}
        <div className={styles.footer}>
          <div className={styles.cancel} onClick={handleCloseModal}>
            {t("Cancel")}
          </div>
          <div
            className={
              hasEAValidationError ? styles.verifying : styles.add
            }
            onClick={actionHandler}
            aria-disabled={hasEAValidationError}
          >
            {actionText}
          </div>
        </div>
      </div>
    </div>
  );
});
